import React, { useState, useRef ,useEffect } from 'react';
import AutocompleteAirport from './AutocompleteAirport';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom'; // Assuming you're using React Router
import { FaUser, FaChild } from 'react-icons/fa'; // Icons for Adults/Children
import { GiBabyBottle } from 'react-icons/gi'; // Icon for Infants
import { IoMdArrowDropdown } from 'react-icons/io'; // Down arrow icon
import { CiSearch } from "react-icons/ci";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaPlaneDeparture } from "react-icons/fa";
import { FaPlaneArrival } from "react-icons/fa";


function HotelSearchForm(){

    {/*Origin Destination Fields*/} 
    const [destination, setDestination] = useState('');

    {/*Dates Selection Start */}
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleDateChange = (dateOrDates) => {
        setShowUserInfo(true);
        const [start, end] = dateOrDates; // Array destructuring for "Round Trip"
        setStartDate(start);
        setEndDate(end);
    
    };

    const formatDate = (date) => {
        if (!date) return '';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };
    {/*Dates Selection End */}
    

    {/*Passenger Select COde Start */} 
    const [isOpen, setIsOpen] = useState(false);
    const [passengers, setPassengers] = useState({
        adults: 1,
        children: 0,
        rooms: 1,
    });

    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handlePassengerChange = (type, operation) => {
        setPassengers((prev) => {
            let newValue;
            if (type === 'adults') {
                // Ensure adults count does not go below 1
                newValue = operation === 'increment' ? prev[type] + 1 : Math.max(prev[type] - 1, 1);
            } else {
                // Allow other passenger types to go down to 0
                newValue = operation === 'increment' ? prev[type] + 1 : Math.max(prev[type] - 1, 0);
            }
            
            return { ...prev, [type]: newValue };
        });
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    {/*Passenger Select COde End */}
   
     // Disable keyboard input on datepicker field
    const disableKeyboardInput = (event) => {
        event.preventDefault();
    };
    
    {/*Name, Email, Phone Field*/}
    const [username, setUsername]=useState('');
    const [useremail, setUseremail] = useState('');
    const [phonenumber, setPhonenumber] = useState('');
    const [showUserInfo, setShowUserInfo] = useState(false); // To show user info fields

    {/* Handle Form Submission (Send Data to API */}
    const [errors, setErrors] = useState({});
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10,15}$/;

    const validateForm = () => {
        const newErrors = {};
        if (!destination) newErrors.destination = 'Destination is required';
        if (!endDate) newErrors.dateError = 'Check in & Check out Dates are required';
        
        if (!username) newErrors.username = 'Name is required';
        if (!useremail) {
            newErrors.useremail = 'Email is required';
        } else if (!emailRegex.test(useremail)) {
            newErrors.useremail = 'Invalid email format';
        }
        if (!phonenumber) {
            newErrors.phonenumber = 'Phone number is required';
        } else if (!phoneRegex.test(phonenumber)) {
            newErrors.phonenumber = 'Invalid phone number format (must be 10-15 digits)';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSearch = async (e) => {
         e.preventDefault();
        if (validateForm()) {

        }
    };

    return (
        <>
        <div className="book-form w-100 mt-1 pb-1 z-index1 rounded">
            
                <div className='row formFieldsRow'>
                    <div className="col-lg mb-2 hotelDestinationField">
                        <div className="form-group">
                            <div className="input-box autoComplete">
                                <label className="mb-3"></label> 
                                {/*<span className='searchFormIcons'><FaPlaneArrival /></span>*/}
                                <AutocompleteAirport label="Where are you going?" onSelectAirport={setDestination} />
                                {errors.destination && <p style={{ color: 'red' }}>{errors.destination}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg mb-2 dateSelectionField">
                        <div className="form-group ">
                            <div className="input-box">
                            <label className="mb-3"></label>
                            {/*<span className='searchFormIcons'><FaRegCalendarAlt /></span>*/}
                            <DatePicker
                                id="date-range"
                                selected={startDate}
                                onChange={handleDateChange}
                                startDate={startDate}
                                endDate={endDate }
                                selectsRange
                                monthsShown={2} // Show 2 months in one view
                                minDate={new Date()} // Disable past dates 
                                placeholderText="Check-in Date - Check-out Date"
                                autoComplete="off"
                                dateFormat="dd/MM/yyyy"
                                onKeyDown={disableKeyboardInput} // Disable keyboard input
                                popperPlacement="bottom-end"
                                popperProps={{
                                    positionFixed: true
                                }}
                                withPortal
                                onFocus={e => e.target.blur()}
                                />
                                {errors.dateError && <p style={{ color: 'red' }}>{errors.dateError}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 mb-2 passengerSelectionField">
                        <div className="form-group">
                            <div className="input-box">
                                <label className="mb-3"></label>
                                <div className="passenger-dropdown" ref={dropdownRef}>
                                    {/* Passenger Button */}
                                    <button className="passenger-button" onClick={toggleDropdown}>
                                        Passengers <IoMdArrowDropdown className="dropdown-arrow" />
                                    </button>

                                    {/* Dropdown Content */}
                                    {isOpen && (
                                        <div className="dropdown-content passengerCalculate">
                                        <div className="passenger-row">
                                            {/*<FaUser className="icon" />*/}
                                            <div>
                                            <span>Adults</span>
                                            <p>Ages 13 or above</p>
                                            </div>
                                            <div className="counter">
                                            <button onClick={() => handlePassengerChange('adults', 'decrement')}>-</button>
                                            <span>{passengers.adults}</span>
                                            <button onClick={() => handlePassengerChange('adults', 'increment')}>+</button>
                                            </div>
                                        </div>
                                        <div className="passenger-row">
                                            {/*<FaChild className="icon" />*/}
                                            <div>
                                            <span>Children</span>
                                            <p>Ages 2–12</p>
                                            </div>
                                            <div className="counter">
                                            <button onClick={() => handlePassengerChange('children', 'decrement')}>-</button>
                                            <span>{passengers.children}</span>
                                            <button onClick={() => handlePassengerChange('children', 'increment')}>+</button>
                                            </div>
                                        </div>
                                        <div className="passenger-row">
                                            {/*<GiBabyBottle className="icon" />*/}
                                            <div>
                                            <span>Rooms</span>
                                            <p></p>
                                            </div>
                                            <div className="counter">
                                            <button onClick={() => handlePassengerChange('rooms', 'decrement')}>-</button>
                                            <span>{passengers.rooms}</span>
                                            <button onClick={() => handlePassengerChange('rooms', 'increment')}>+</button>
                                            </div>
                                        </div>
                                        <button className="apply-button" onClick={() => setIsOpen(false)}>
                                            Apply
                                        </button>
                                        </div>
                                        )}
                                </div>
                            </div>
                        </div>    
                    </div>
                    <div className="col-lg-1 mb-2 flightSearchBtn hideSearchBtn">
                        <div className="form-group mb-0 text-center">
                            <div className="input-box">
                                <label className="mb-3"></label><br />
                                <button className="nir-btn w-100 search-button" onClick={handleSearch}><CiSearch /></button>
                            </div>    
                        </div>
                    </div>
                </div>
                {showUserInfo &&(        
                <div className='row' >
                        <div className='col-lg-4 searchFullName'>
                            <div className="form-group">
                                <div className="input-box">
                                    <label></label>
                                    <input type="text" name="fullname" autoComplete="off" placeholder='Your Name' value={username} onChange={(e) => setUsername(e.target.value)}/>
                                    {errors.username && <p style={{ color: 'red' }}>{errors.username}</p>}
                                </div>
                            </div>
                        </div> 
                        <div className='col-lg-4 searchEmail'>
                            <div className="form-group">
                                <div className="input-box">
                                    <label></label>
                                    <input type="email" name="useremail" autoComplete="off" placeholder='Your Email' value={useremail} onChange={(e) => setUseremail(e.target.value)} />
                                    {errors.useremail && <p style={{ color: 'red' }}>{errors.useremail}</p>}
                                </div>
                            </div>
                        </div> 
                        <div className='col-lg-4 searchPhoneNumber'>
                            <div className="form-group">
                                <div className="input-box">
                                    <label></label>
                                    <input type="text" name="phonenumber" autoComplete="off" placeholder='Your Phone' value={phonenumber} onChange={(e) => setPhonenumber(e.target.value)} />
                                    {errors.phonenumber && <p style={{ color: 'red' }}>{errors.phonenumber}</p>}
                                </div>
                            </div>
                        </div> 
                        
                    </div>            
                    )}
                    <div className='row showSearchBtn'  >
                        <div className="col-lg-1 mb-2 flightSearchBtn">
                            <div className="form-group mb-0 text-center">
                                <div className="input-box">
                                    <label className="mb-3"></label><br />
                                    <button className="nir-btn w-100 search-button" onClick={handleSearch}><CiSearch /></button>
                                </div>    
                            </div>
                        </div>   
                    </div>
                 
            
        </div>
        </>
    )
}
export default HotelSearchForm;  